import BaseListItemText from '@material-ui/core/ListItemText'

const ListItemText = BaseListItemText

export default ListItemText
